import { useParams } from "react-router-dom";
import { useEffect } from "react";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import {pageMenuTabList01} from 'types/common';

import { fnSetTimeTab } from "assets/js/commonUtil";

import 'assets/css/company.scss';

export default function Manufacture() {
  const { id } = useParams<{ id: string }>();

  const typeProp = [    
    { tabText: '치어팩 [M방형]', text: '액상팩 : 40~200 mL<br/>워터젤리 : 40~150 g', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-08_300x300.png' },
    { tabText: '치어팩 [스탠딩]', text: '액상팩 : 40~200 mL<br/>워터젤리 : 40~150 g', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-09_300x300.png' },
    { tabText: '치어팩 [안전캡]', text: '액상팩 : 40~200 mL', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-10_300x300.png' },
    { tabText: '사면포', text: '액상팩 : 40~80 mL', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-11_300x300.png' },
  ];

  const facilitiesProp = [
    { tabText: '치어팩 [일반]', text: '설비수량:4대<br/>생산능력:12톤/135,000팩', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-12_300x300.png' },
    { tabText: '치어팩 [안전캡]', text: '설비수량:1대<br/>생산능력:3톤/33,000팩', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-13_300x300.png' },
    { tabText: '사면팩', text: '설비수량:1대<br/>생산능력:3톤/39,000팩', url:'https://img.chunhomall.com/images/brand_site/production-section-liquid-14_300x300.png' },

  ];

  const vialProp = [
    { tabText: '스크류 바이알', text: 'PP(화이트)<br/>20~30mL, 50mL<br/><br/>내열PET(브라운)<br/>20~25mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-01.png' },
    { tabText: '멀티캡 바이알<br/>(이중 제형)', text: '20~25mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-02.png' },
    { tabText: '삿갓 바이알', text: '유리<br/>20~30mL<br/><br/>PCT<br/>20 mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-03.png' },
    { tabText: '멀티캡 삿갓캡<br/>(이중 제형)', text: '유리<br/>20~30mL<br/><br/>PCT<br/>20 mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-04.png' },
    { tabText: '멀티캡 치어팩<br/>(이중 제형)', text: '50~150mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-05.png' },
  ];

  pageMenuTabList01[2].on = true;

  useEffect(() => {  
    
    fnSetTimeTab();

  }, []);

  const typeRendering = () => {
    const result = [];
    for (let i = 0; i < typeProp.length; i++) {
      result.push(
        <div className="img-style">
          <div className="img-inner bgF7F7F7">
            <img src={typeProp[i].url} alt="Manufacture Image" />
            <div className="img-inner-text">
              {typeProp[i].tabText}
            </div>
          </div>
          <div className="img-text">
            <div dangerouslySetInnerHTML={{__html: typeProp[i].text}}></div>
          </div>
        </div>
      );
    }
    return result;
  }

  const facilitiesRendering = () => {
    const result = [];
    for (let i = 0; i < facilitiesProp.length; i++) {
      result.push(
        <div className="img-style">
          <div className="img-inner bgF7F7F7">
            <img src={facilitiesProp[i].url} alt="Manufacture Image" />
            <div className="img-inner-text">
              {facilitiesProp[i].tabText}
            </div>
          </div>
          <div className="img-text">
            <div dangerouslySetInnerHTML={{__html: facilitiesProp[i].text}}></div>
          </div>
        </div>
      );
    }
    return result;
  }

  const vialRendering = () => {
    const result = [];
    for (let i = 0; i < vialProp.length; i++) {
      result.push(
        <div className="img-style">
          <div className="img-inner bgF7F7F7">
            <img src={vialProp[i].url} alt="Manufacture Image" />
            <div className="img-inner-text" dangerouslySetInnerHTML={{__html: vialProp[i].tabText}}></div>
          </div>
          <div className="img-text">
            <div dangerouslySetInnerHTML={{__html: vialProp[i].text}}></div>
          </div>
        </div>
      );
    }
    return result;
  }


  return (
    <div className="page_content manufacture-content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/production-hero_1920x1080.jpg.jpg" imgText="제조설비" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList01}></PageTab>
      <div className="container">
        <div className="container-title">
          첨단 설비와 철저한 안전·위생관리를 통해<br/>
          믿을 수 있는 제품만을 생산합니다.
        </div>

        <div className="page-inner-tab">
          <div className="tabs col2">
            <div className="tab on">액상 설비</div>
            <div className="tab">고상/스틱 설비</div>
            <div className="tab">바이알/멀티캡</div>
          </div>
        </div>
        <div className="page-inner-tab">
          <div className="tab-list on">
            <div className="container-item">
              <div className="container-item-title">액상설비</div>
              <div className='container-img-grid liquid'>
                <div className="img-style img1">
                  <div className="img-inner">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-01_830x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      1. 원료 세척
                    </div>
                  </div>
                  <div className="img-text">
                    자동화된 버블 세척 시스템으로 원료의 미세한 이물질까지 깨끗하게 세척합니다.
                  </div>
                </div>
                <div className="img-style img2">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-02_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      2. 추 출
                    </div>
                  </div>
                  <div className="img-text">
                    원료에 따라 적합한 최상의 방식으로 추출합니다.
                  </div>
                </div>
                <div className="img-style img3">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-03_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      3. 농 축
                    </div>
                  </div>
                  <div className="img-text">
                    저온진공농축으로 영양성분 파괴를 최소화 합니다.
                  </div>
                </div>
                <div className="img-style img4">
                  <div className="img-inner">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-04_830x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      4. 혼 합
                    </div>
                  </div>
                  <div className="img-text">
                    천호엔케어만의 적절한 배합 비율로 맛과 영양을 조화롭게 배합합니다.
                  </div>
                </div>
                <div className="img-style img5">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-05_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      5. 착 즙
                    </div>
                  </div>
                  <div className="img-text">
                    원액 그대로의 상태를 선보이기 위해 물 없이 착즙합니다. (착즙 제품)
                  </div>
                </div>
                <div className="img-style img6">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-06_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      6. 여과/살균
                    </div>
                  </div>
                  <div className="img-text">
                    정밀 여과로 이물질을 제거하고 초고온순간살균(UHT)으로 일반세균 및 미생물을 제어합니다.
                  </div>
                </div>
                <div className="img-style img7">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-liquid-07_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      7. 충진/포장
                    </div>
                  </div>
                  <div className="img-text">
                    자동 충전 시스템을 통해 개별 파우치에 빠르고 위생적으로 충전합니다.
                  </div>
                </div>
              </div>
              <div className="container-item-title">생산가능 형태</div>
              <div className='container-img-grid col4'>
                {typeRendering()}
              </div>
              <div className="container-item-title">
                생산설비 현황
                <div className="container-item-subtitle">가동시간:1일 8시간 가동기준 / 생산능력:일평균 생산량 기준</div>
              </div>
                  
              <div className='col4 grid-style'>
                <div className="header-style">
                  구분
                </div>
                <div className="header-style">
                  치어팩(일반)
                </div>
                <div className="header-style">
                  치어팩(안전캡)
                </div>
                <div className="header-style">
                  사면팩
                </div>
                
                <div className="con-style">
                  설비수량
                </div>
                <div className="con-style">
                  4대
                </div>
                <div className="con-style">
                  생산능력
                </div>
                <div className="con-style">
                  1대
                </div>
                <div className="con-style">
                  1대
                </div>
                <div className="con-style">
                  12톤
                </div>
                <div className="con-style">
                  3톤
                </div>
                <div className="con-style">
                  3톤
                </div>
                
                <div className="con-style">
                  135,000팩
                </div>
                <div className="con-style">
                  33,000팩
                </div>
                <div className="con-style">
                  39,000팩
                </div>
              </div>
              <div className="movieArea">
                <div className="movieItem">
                  <iframe className="movieItemStyle" src="https://www.youtube.com/embed/GTuYPrJtalk?playlist=GTuYPrJtalk&controls=0&loop=1&rel=0" 
                  title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>
                <div className="movieItem">
                  <iframe className="movieItemStyle" src="https://www.youtube.com/embed/cWTQm7TegM8?playlist=cWTQm7TegM8&controls=0&loop=1&rel=0" 
                  title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>
              </div>

            </div>
            
          </div>
          
          <div className="tab-list">
            <div className="container-item">
              <div className="container-item-title">소환/대환</div>
              <div className='container-img-grid stick'>
                <div className="img-style img1">
                  <div className="img-inner img-crop-side">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-01_830x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      1. 성 형
                    </div>
                  </div>
                  <div className="img-text">
                    분말을 환 형태로 제조합니다.
                  </div>
                </div>
                <div className="img-style img2">
                  <div className="img-inner imgx1">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-02_600x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      2. 선 별
                    </div>
                  </div>
                  <div className="img-text">
                    성형이 완료된 소환을 선별합니다.
                  </div>
                </div>
                <div className="img-style img3">
                  <div className="img-inner imgx1">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-03_600x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      3. 코 팅
                    </div>
                  </div>
                  <div className="img-text">
                    원료농축액으로 코팅합니다.
                  </div>
                </div>
                
                <div className="img-style img4">
                  <div className="img-inner  img-crop-side">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-04_830x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      4. 포 장
                    </div>
                  </div>
                  <div className="img-text">
                    용량에 맞춰 포장합니다
                  </div>
                </div>
                
              </div>
              <div className="container-item-title">생산 가능 형태</div>
              <div className='container-img-grid col2 wide'>
                <div className="img-style">
                  <div className="img-inner bgF7F7F7">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-05_300x300.png`} alt="Manufacture Image" />
                    <div className="img-inner-text">
                      소(小)환
                    </div>
                  </div>
                  <div className="img-text">
                    소환 : 3 ~ 4 g/포
                  </div>
                </div>
                <div className="img-style">
                  <div className="img-inner bgF7F7F7">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-06_300x300.png`} alt="Manufacture Image" />
                    <div className="img-inner-text">
                      대(大)환
                    </div>
                  </div>
                  <div className="img-text">
                    대환 : 4.0 ~ 4.5 g
                  </div>
                </div>
              </div>
              
              <div className="container-item-title">생산 설비 현황</div>
              <div className='container-grid'>
                <div className="header-style">
                  구분
                </div>
                <div className="header-style">
                  제환
                </div>
                <div className="header-style">
                  선별
                </div>
                <div className="header-style">
                  코팅
                </div>
                <div className="header-style">
                  충전
                </div>
                <div className="con-style">
                  설비수량
                </div>
                <div className="con-style">
                  2대
                </div>
                <div className="con-style">
                  1대
                </div>
                <div className="con-style">
                  1대
                </div>
                <div className="con-style">
                  10열 1대<br/>
                  대환 2대
                </div>
                <div className="con-style">
                  생산능력
                </div>
                <div className="con-style">
                  40kg/hr
                </div>
                <div className="con-style">
                  20kg/hr
                </div>
                <div className="con-style">
                  50kg/hr
                </div>
                <div className="con-style">
                  10열(10,800p/hr)<br/>대환(3,600p/hr)
                </div>
              </div>

              <div className="container-item-title paddingTop50">스틱</div>
              <div className='container-img-grid col3'>
                <div className="img-style">
                  <div className="img-inner img-part imgx2">
                    <img src={`https://img.chunhomall.com/images/brand_site/production-section-stick-07_600x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      1. 배합
                    </div>
                  </div>
                  <div className="img-text">
                    고속 믹서를 활용한 정밀 배합으로 본연의 맛을 최대한 유지합니다.
                  </div>
                </div>
                <div className="img-style">
                  <div className="img-inner img-part">
                    <img src={`https://img.chunhomall.com/images/brand_site//production-section-stick-08_400x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      2. 충전
                    </div>
                  </div>
                  <div className="img-text">
                    자동충전시스템으로 개별 스틱포에 빠르고 위생적으로 충전합니다.
                  </div>
                </div>
                <div className="img-style">
                  <div className="img-inner img-part imgx2">
                    <img src={`https://img.chunhomall.com/images/brand_site//production-section-stick-09_600x400.jpg.jpg`} alt="Manufacture Image" />
                    <div className="img-inner-text up">
                      3. 포장
                    </div>
                  </div>
                  <div className="img-text">
                    로봇을 이용한 자동포장으로 빠르고 정밀하게 포장합니다.
                  </div>
                </div>
              </div>
              <div className="stick-info">
                <div className="item info01">
                  <div className="item-title">생산 가능 형태</div>
                  <div className="img-inner  img-part">
                    <img src="https://img.chunhomall.com/images/brand_site/production-section-stick-10_300x300.png" alt=""></img>
                    <div className="img-inner-text up">
                      스틱포
                    </div>
                  </div>
                  <div className="img-text">
                    액상스틱 : 10 ~ 25ml<br/>
                    젤리스틱 : 15 ~ 25g
                  </div>
                </div>
                <div className="item info02">
                  <div className="item-title">생산 설비 현황</div>
                  <div className='col3 grid-style'>
                    <div className="header-style">
                      구분
                    </div>
                    <div className="header-style">
                      액상스틱
                    </div>
                    <div className="header-style">
                      젤리스틱
                    </div>
                    
                    <div className="con-style">
                      설비수량
                    </div>
                    <div className="con-style">
                      2대
                    </div>
                    <div className="con-style">
                      1대
                    </div>
                    
                    <div className="con-style">
                      생산능력
                    </div>
                    <div className="con-style">
                      1톤
                    </div>
                    <div className="con-style">
                      1톤
                    </div>
                    
                    <div className="con-style">
                      90,000포
                    </div>
                    <div className="con-style">
                      45,000포
                    </div>
                  </div>
                  <div className="img-text">
                    기동시간 : 1일 8시간 가동 기준<br/>
                    생산능력 : 일평균 생산량 기준
                  </div>
                </div>
              </div>
              <div className="movieArea">
                <div className="movieItem">
                  <iframe className="movieItemStyle" src="https://www.youtube.com/embed/DJGJOzoG0ng?playlist=DJGJOzoG0ng&controls=0&loop=1&rel=0" 
                  title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>
              </div>
            </div>
          </div>


          <div className="tab-list">
            <div className="container-item">
              <div className="container-item-title">생산가능 형태</div>
              <div className='container-img-grid col5'>
                {vialRendering()}
              </div>

              <div className="container-item-title">
                생산설비 현황
                <div className="container-item-subtitle">가동 시간:1일 8시간 가동기준 / 생산능력:일평균 생산량 기준</div>
              </div>
              <div className='container-grid col3'>
                <div className="header-style">
                  구분
                </div>
                <div className="header-style">
                  바이알
                </div>
                <div className="header-style">
                  멀티캡
                </div>

                <div className="con-style">
                  설비수량
                </div>
                <div className="con-style">
                  1대
                </div>
                <div className="con-style">
                  1대
                </div>

                <div className="con-style">
                  생산능력
                </div>
                <div className="con-style">
                  25,000병
                </div>
                <div className="con-style">
                  25,000개
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
